'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDown = function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown(props) {
    _classCallCheck(this, DropDown);

    var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props));

    _this.state = {
      fold: {
        left: false,
        top: false
      },
      show: false
    };

    _this.showList = _this.showList.bind(_this);
    _this.hideList = _this.hideList.bind(_this);
    _this.alignDropdown = _this.alignDropdown.bind(_this);
    return _this;
  }

  _createClass(DropDown, [{
    key: 'showList',
    value: function showList() {
      this.setState(function () {
        return { show: true };
      });
    }
  }, {
    key: 'hideList',
    value: function hideList() {
      var _this2 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var target = e.currentTarget;

      setTimeout(function () {
        if (!e || !target.contains(document.activeElement))
          //resetState
          _this2.setState(function () {
            return {
              fold: {
                left: false,
                top: false
              },
              show: false
            };
          });
      }, 0);
    }
  }, {
    key: 'alignDropdown',
    value: function alignDropdown(_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          horizontal = _ref2[0],
          vertical = _ref2[1];

      this.setState(function () {
        return {
          fold: {
            left: horizontal,
            top: vertical
          }
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var alignDropdown = this.alignDropdown,
          hideList = this.hideList,
          _props = this.props,
          items = _props.items,
          wrapper = _props.wrapper,
          state = this.state;

      var props = Object.assign({}, this.props);
      delete props['items'];

      return _react2.default.createElement(
        'div',
        { tabIndex: 0, style: _styles2.default.dropdown, onBlur: this.hideList },
        _react2.default.createElement(_Item2.default, _extends({}, this.props, { action: this.showList })),
        state.show ? getList(state.fold, items, wrapper, hideList, alignDropdown) : null
      );
    }
  }]);

  return DropDown;
}(_react.Component);

var getList = function getList(fold, items, wrapper, hideList, alignDropdown) {
  var style = Object.assign({}, _styles2.default.list, fold.left ? _styles2.default.justifyRight : {}, fold.top ? _styles2.default.valignTop : {});

  return _react2.default.createElement(
    'div',
    { style: style },
    items.map(function (item, index) {
      var action = item.action;
      if (typeof action !== 'undefined') item.action = function () {
        hideList();
        action();
      };
      // Additional dropdown specifics to add
      item.alignDropdown = alignDropdown;
      item.wrapper = wrapper;

      return _react2.default.createElement(_Item2.default, _extends({ key: index }, item));
    })
  );
};

exports.default = DropDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/components/lib/components/Dropdown/index.js
// module id = 399
// module chunks = 5